import { createContext, useContext } from 'react';
import { CmsResult } from './fetch-nsp-data';
import NspContextWrapper from './nsp-data-wrapper';

/** A React context for an NSP object. */
const NspContext = createContext<CmsResult>({});
export default NspContext;

/** A React context provider for an NSP object. */
export const NspProvider = NspContext.Provider;

/** Allows the current component to access the page's NSP data. */
export function useNspContext(): NspContextWrapper {
  return new NspContextWrapper(useContext(NspContext));
}
